<div class="modal-confirm">
  <div class="modal-confirm__header">
    <h2 class="modal-confirm__title">
      {{ titleKey() | translate }}
    </h2>

    <button class="modal-confirm__close" type="button" (click)="onCancelAddCategory()">
      <app-icon class="icon-close" [icon]="IconName.CLOSE" />
    </button>
  </div>

  <form class="modal-confirm__form" [formGroup]="addCategoryForm" (ngSubmit)="onSubmit()">
    <div class="modal-confirm__inputs">
      <div class="modal-confirm__input-wrapper">
        <mat-label for="name">
          {{ 'shop-settings.categories.categoriesModal.name' | translate }}
        </mat-label>

        <input
          id="name"
          formControlName="name"
          required
          class="modal-confirm__field"
          [class.has-error]="
            addCategoryForm.get('name')?.touched && addCategoryForm.get('name')?.invalid
          "
          [placeholder]="'shop-settings.categories.categoriesModal.namePlaceholder' | translate"
        />

        @if (addCategoryForm.get('name')?.touched && addCategoryForm.get('name')?.errors) {
          <div class="modal-confirm__error-message">
            @switch (true) {
              @case (addCategoryForm.get('name')?.hasError('required')) {
                {{ 'shop-settings.categories.errors.required' | translate }}
              }

              @case (addCategoryForm.get('name')?.hasError('leadingOrTrailingSpaces')) {
                {{ 'shop-settings.categories.errors.nameNoLeadingTrailingSpaces' | translate }}
              }

              @case (addCategoryForm.get('name')?.hasError('invalidLength')) {
                {{ 'shop-settings.categories.errors.nameLengthInvalid' | translate }}
              }

              @case (addCategoryForm.get('name')?.hasError('invalidFormat')) {
                {{ 'shop-settings.categories.errors.nameFormatInvalid' | translate }}
              }

              @case (addCategoryForm.get('name')?.hasError('numericOnly')) {
                {{ 'shop-settings.categories.errors.nameNumericOnlyInvalid' | translate }}
              }

              @case (addCategoryForm.get('name')?.hasError('notUnique')) {
                {{ 'shop-settings.categories.errors.isNotUniqueName' | translate }}
              }
            }
          </div>
        }
      </div>

      <div class="modal-confirm__input-wrapper">
        <mat-label for="url">
          {{ 'shop-settings.categories.categoriesModal.url' | translate }}
        </mat-label>

        <input
          id="url"
          formControlName="url"
          required
          class="modal-confirm__field"
          [class.has-error]="
            addCategoryForm.get('url')?.touched && addCategoryForm.get('url')?.invalid
          "
          [placeholder]="'shop-settings.categories.categoriesModal.urlPlaceholder' | translate"
        />

        @if (addCategoryForm.get('url')?.touched && addCategoryForm.get('url')?.errors) {
          <div class="modal-confirm__error-message">
            {{ urlErrorResponse() | translate }}
          </div>
        }
      </div>

      <div class="modal-confirm__input-wrapper">
        <span class="modal-confirm__label">
          {{ 'shop-settings.categories.categoriesModal.parentCategory' | translate }}
        </span>

        <mat-form-field class="modal-confirm__select-wrapper" appearance="outline">
          <mat-select formControlName="parentCategory">
            @for (parentCategory of parentCategories; track parentCategory.id) {
              <mat-option [value]="parentCategory.id">
                {{ parentCategory.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="modal-confirm__admin">
      <p class="modal-confirm__toggle-wrapper">
        <mat-slide-toggle formControlName="admin" [hideIcon]="true" />
        {{ 'shop-settings.categories.categoriesModal.visibility' | translate }}
      </p>
    </div>

    <div class="modal-confirm__btn-wrapper">
      <button type="button" class="modal-confirm__button btn-white" (click)="onCancelAddCategory()">
        {{ 'shop-settings.categories.categoriesModal.cancel' | translate }}
      </button>

      <button type="submit" class="modal-confirm__button btn-primary">
        {{ submitBtnKey() | translate }}
      </button>
    </div>
  </form>
</div>
